import { Theme } from '@mui/material/styles'

const muiCardHeader = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        padding: '1.5rem',
        '& .MuiCardHeader-action': {
          margin: 0
        },
        '& .MuiCardHeader-avatar': {
          marginRight: 12
        }
      },
      subheader: {
        color: theme.colors.caption,
        marginTop: 8,
        fontSize: '.875rem'
      }
    }
  }
}

export default muiCardHeader
